<template>
  <div class="app">
    <AppHeader :dropdownItems="dropdownItems"></AppHeader>
    <Navigator v-if="showNavigator" :title="routeTitle" :navItems="nav"></Navigator>
    <!-- <SearchSession></SearchSession> -->
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside/> -->
    </div>
    <AppFooter></AppFooter>
    <FaqModal></FaqModal>
    <EventModal></EventModal>
    <CustomMessageModal></CustomMessageModal>
    <EventDetailModal></EventDetailModal>
    <ModalInfo></ModalInfo>
    <ManageEmailModal></ManageEmailModal>
    <EmailHistoriesManagement></EmailHistoriesManagement>
    <EventStaffingDetail></EventStaffingDetail>
  </div>
</template>

<script>
  import nav from '../../_nav';
  import consts from '../../_consts';
  import eventItems from '../../_data';
  import FaqModal from '../../components/modal/FaqModal';
  import CustomMessageModal from '../../components/modal/CustomMessageModal';
  import EventDetailModal from '../../components/modal/event/EventDetailModal';
  import EventModal from '../../components/modal/Modal';
  import ModalInfo from '../../components/modal/ModalInfo';
  import ManageEmailModal from '../../views/email/ManageEmail';
  import EmailHistoriesManagement from '../../views/email/EmailHistoriesManagement';
  import EventStaffingDetail from '../../views/staffing/EventStaffingDetail';
  import {mapGetters} from 'vuex';
  import {
    Header as AppHeader,
    Footer as AppFooter,
    Breadcrumb,
    Navigator,
    ClientCardsManagement,
    SearchSession
  } from '../../components/commons';

  export default {
    name: 'managerDashboard',
    components: {
      AppHeader,
      AppFooter,
      Breadcrumb,
      Navigator,
      ClientCardsManagement,
      SearchSession,
      FaqModal,
      CustomMessageModal,
      EventModal,
      ModalInfo,
      EventDetailModal,
      ManageEmailModal,
      EmailHistoriesManagement,
      EventStaffingDetail
    },
    fields: {
      name: {label: 'Person Full name', sortable: true},
      age: {label: 'Person age', sortable: true, 'class': 'text-center'},
      isActive: {label: 'is Active'},
      actions: {label: 'Actions'}
    },
    data () {
      return {
        nav: nav.managerDashboardNav,
        eventItems: eventItems.eventItems,
        dropdownItems: nav.dropdownItems
      };
    },
    computed: {
      showNavigator () {
        let view = this.getManagerView;
        return view === consts.viewNames.managerEvent || view === consts.viewNames.managerDashboard || view === consts.viewNames.planAndApprove || view === consts.viewNames.staffing || view === consts.viewNames.manageApprovedDashboard;
      },
      ...mapGetters({
        getManagerView: 'GETTER_GET_MANAGER_VIEW'
      })
    },
    props: ['routeTitle'],
    mounted () {
      this.$store.dispatch('ACTION_GET_EVENT_COUNT');
      this.$store.dispatch('ACTION_SET_SHOW_RELATED_EVENT', false);
      this.$store.dispatch('ACTION_RESTART_LIST_EVENT_STATUS', []);
      this.$store.dispatch('ACTION_RESET_SEARCH_CLIENTS');
    }
  };
</script>



// WEBPACK FOOTER //
// Dashboard.vue?94843d2e